import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type { Violation, CompiledPattern } from './validation.types'

export function useForbiddenWordCheck(
  text: string,
  compiledPatterns: CompiledPattern[] | undefined,
): Violation[] {
  const { t } = useTranslation()
  return useMemo(() => {
    if (!compiledPatterns?.length || !text) return []
    const violations: Violation[] = []
    for (const p of compiledPatterns) {
      const re = new RegExp(p.regex.source, p.regex.flags)
      const match = re.exec(text)
      if (match) {
        violations.push({
          type: 'forbidden',
          severity: p.severity,
          message: t('remake.validation.forbidden', { word: match[0], category: p.category }),
          category: p.category,
        })
      }
    }
    return violations
  }, [text, compiledPatterns, t])
}
